// frontend/src/pages/PricingPage.js
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import axios from 'axios';
 
const API = process.env.REACT_APP_BACKEND_URL;
 
const PLANS = [
  { key: 'weekly',       label: 'Weekly Access',          price: '$10/week',  desc: '100 rotating questions per week' },
  { key: 'all',          label: 'All 400 Questions',      price: '$40',       desc: 'One-time payment, never expires' },
  { key: 'section_ai',   label: 'AI Workloads Section',   price: '$10',       desc: '80 AI workload questions' },
  { key: 'section_ml',   label: 'Machine Learning',       price: '$10',       desc: '80 machine learning questions' },
  { key: 'section_cv',   label: 'Computer Vision',        price: '$10',       desc: '80 computer vision questions' },
  { key: 'section_nlp',  label: 'Natural Language',       price: '$10',       desc: '80 NLP questions' },
  { key: 'section_genai','label': 'Generative AI',        price: '$10',       desc: '80 generative AI questions' },
];
 
export default function PricingPage() {
  const navigate = useNavigate();
 
  async function handleCheckout(plan) {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return navigate('/login');
 
    const res = await axios.post(`${API}/api/payments/checkout`, { plan }, {
      headers: { Authorization: `Bearer ${session.access_token}` }
    });
    window.location.href = res.data.url; // Redirect to Stripe checkout
  }
 
  return (
    <div style={{ maxWidth: '960px', margin: '0 auto', padding: '60px 20px' }}>
      <h1 style={{ textAlign: 'center', color: '#1E3A5F', marginBottom: '8px' }}>
        Choose Your Plan
      </h1>
      <p style={{ textAlign: 'center', color: '#555', marginBottom: '48px', fontSize: '18px' }}>
        Unlock the questions you need. No hidden fees.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '20px' }}>
        {PLANS.map(plan => (
          <div key={plan.key} style={{ background: '#fff', border: '2px solid #e0e0e0',
            borderRadius: '16px', padding: '28px', textAlign: 'center',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
            <h3 style={{ color: '#1E3A5F', margin: '0 0 8px' }}>{plan.label}</h3>
            <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#1A6B3A', margin: '12px 0' }}>
              {plan.price}
            </div>
            <p style={{ color: '#666', marginBottom: '24px', fontSize: '14px' }}>{plan.desc}</p>
            <button onClick={() => handleCheckout(plan.key)}
              style={{ width: '100%', padding: '14px', background: '#1E3A5F', color: '#fff',
                border: 'none', borderRadius: '10px', fontSize: '16px', cursor: 'pointer' }}>
              Get Access
            </button>
          </div>
        ))}
      </div>
      <p style={{ textAlign: 'center', marginTop: '32px', color: '#888', fontSize: '14px' }}>
        Payments processed securely by Stripe. Cancel anytime.
      </p>
    </div>
  );
}
